import * as React from "react";
import Button from "@material-ui/core/Button";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Select from "react-select";
import handleMutationError from "app/utils/handleMutationError";
import { withRouter } from "react-router-dom";

type Props = {
  statusMessage: any;
  onClose: Function;
  data: any;
  createApplicationStatusMessage: any;
  history: any;
};

type State = {
  loading: boolean;
  application: any;
  data: any;
  options: any;
};

class ApplicationStatusMessageConfirmationModal extends React.Component<
  Props,
  State
> {
  state = { loading: true, application: null, data: [], options: [] };

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({ loading: true });
    this.props.data.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({
          data: fetchMoreResult.applications,
          loading: false,
          options: fetchMoreResult.applications.map((application) => ({
            value: application.id,
            label: application.application_name,
          })),
        });
      },
    });
  }

  submit = () => {
    this.setState({ loading: true });
    this.props
      .createApplicationStatusMessage({
        variables: {
          status_message_id: this.props.statusMessage.id.toString(),
          application_id: this.state.application.value.toString(),
        },
      })
      .then(() => {
        this.setState({ loading: false });
        this.props.history.push({
          pathname: "/snapscan/ops/application_status_messages/active",
        });
      })
      .catch((error) => {
        handleMutationError(error);
      });
  };

  handleSelect = (event) => {
    this.setState({ application: event });
  };

  render() {
    const { options, application } = this.state;

    return (
      <Dialog
        open={this.props.data?.applications != null}
        onClose={() => this.props.onClose()}
      >
        <DialogTitle>
          <DialogContentText>Confirm status message:</DialogContentText>
        </DialogTitle>
        <DialogContent style={{ width: "400px", height: "100px" }}>
          <Select
            styles={{
              menu: (base) => ({ ...base, color: "black" }),
            }}
            placeholder="Applications"
            onChange={this.handleSelect}
            options={options}
          ></Select>
          {this.state.application && (
            <DialogContentText style={{ padding: "10px" }}>
              The following message{" "}
              <strong>{this.props.statusMessage.message_body}</strong>. Will be
              displayed on <strong>{this.state.application.label}</strong> with
              a level of <strong>{this.props.statusMessage.level}</strong>.
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => this.props.onClose()}>
            Cancel
          </Button>
          <Button
            disabled={application == null}
            color="primary"
            onClick={this.submit}
          >
            {this.state.loading ? "Updating" : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const createApplicationStatusMessage = graphql(
  gql`
    mutation createApplicationStatusMessage(
      $status_message_id: String!
      $application_id: String!
    ) {
      create_application_status_message(
        status_message_id: $status_message_id
        application_id: $application_id
      )
    }
  `,
  { name: "createApplicationStatusMessage" }
);

const applicationsQuery = gql`
  query AllApplications {
    applications {
      id
      application_name
    }
  }
`;

const applicationsQueryGraphql = graphql(applicationsQuery);

export default withRouter(
  compose<any>(
    applicationsQueryGraphql,
    createApplicationStatusMessage
  )(ApplicationStatusMessageConfirmationModal)
);
